import React from 'react'
import styled from 'styled-components'

import { translate } from '~/core/translate'
import { ColumnFlexCentered } from './containers'
import { CDN_URL } from '~/core/constants'

const imgUrl = `${CDN_URL}/no-results.png`

const Container = styled(ColumnFlexCentered)`
  color: ${({ theme }) => theme.colorSecondary};
  padding: 32px;
  
  img {
    margin-bottom: 8px;
  }
`

const NoResults = () => {
  return (
    <Container>
      <img src={imgUrl} />
      <span>{translate('no_results')}</span>
      <span>{translate('no_results_alternative_keywords')}</span>
    </Container>
  )
}

export default NoResults
